export default "__VITE_ASSET__e92ae5aa__"